import * as yup from "yup";

export default function schema() {
  const hasValue = (value) => value != null && String(value).trim() !== "";

  const hasAnySendingAddressValue = (value) => {
    const address = value ?? {};

    return [
      address.ulica,
      address.hisnaStevilka,
      address.postnaStevilka,
      address.posta,
      address.drzava,
    ].some(hasValue);
  };

  const optionalSendingAddressSchema = yup
    .object()
    .shape({
      ulica: yup.string().nullable().trim(),
      hisnaStevilka: yup.string().nullable().trim(),
      naslovDrugaVrstica: yup.string().nullable().trim(),
      postnaStevilka: yup.string().nullable().trim(),
      posta: yup.string().nullable().trim(),
      drzava: yup.string().nullable().trim(),
    })
    .nullable();

  const requiredSendingAddressSchema = yup
    .object()
    .shape({
      ulica: yup.string().nullable().trim().required(),
      hisnaStevilka: yup.string().nullable().trim().required(),
      naslovDrugaVrstica: yup.string().nullable().trim(),
      postnaStevilka: yup.string().nullable().trim().required(),
      posta: yup.string().nullable().trim().required(),
      drzava: yup.string().nullable().trim().required(),
    })
    .nullable();

  return {
    breeder: yup.object().shape({
      telefon: yup.string().nullable(),
      naslovZaPosiljanje: yup.lazy((value) =>
        hasAnySendingAddressValue(value)
          ? requiredSendingAddressSchema
          : optionalSendingAddressSchema
      ),
    }),
  };
}
